module.exports = __webpack_public_path__ + "img/archive.e0b24f3d.svg";